<template>
  <transition appear @before-enter="beforeEnter" @enter="enter" @leave="leave">
    <i class="Icon" :class="iconClasses" v-html="svgContent" />
  </transition>
</template>

<script>
export default {
  name: 'BwrIcon',
  props: {
    svgContent: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: null,
    },
    animate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconClasses() {
      const classes = []
      if (this.size) {
        classes.push(`Icon--${this.size}`)
      }
      if (this.animate) {
        classes.push('Icon--animated')
      }
      return classes
    },
  },
  methods: {
    beforeEnter: function (el) {
      if (this.animate) {
        this.path = el.querySelector('path')
        const length = this.path.getTotalLength()
        this.path.style.strokeDasharray = length
        this.path.style.strokeDashoffset = length
        this.path.style.transition = 'stroke-dashoffset .2s ease-in-out'
      }
    },
    enter: function () {
      if (this.animate) {
        setTimeout(() => {
          this.path.style.strokeDashoffset = 0
        }, 100)
      }
    },
    leave: function () {
      if (this.animate) {
        this.$el.style.display = 'none'
      }
    },
  },
}
</script>

<style>
.Icon {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}

.Icon > svg {
  display: block;
  max-height: 100%;
}
</style>
